import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-753b6df1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-box" }
const _hoisted_2 = { class: "left-box" }
const _hoisted_3 = { class: "logo_div" }
const _hoisted_4 = { src: "https://image.kilimall.com/kenya/PcImages/logo/icon_164_x3.png.webp" }
const _hoisted_5 = { class: "left-text" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "lang-select" }
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = { class: "lang-text" }

import { useRoute, useRouter } from 'vue-router'
import { watchEffect, ref } from 'vue'
import { getTopicLanguage } from '@/api/help-center'
import KlIcon from "@/components/icon-picker/KLIcon.vue";
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const language = ref<any>({})
const languageList = ref([])

const handleCommand = (command) => {
  // const id = route.params.id || route.query.id

  // window.open(`/help-center/home/${command.id}/${id}`)
  let url = `/help-center/${command.id}`
  // if (id) {
  //   url += `/${id}`
  // }
  window.location.href = url
}

const getTopicLanguageFn = async(mid: string) => {
  try {
    const res = await getTopicLanguage(mid)
    let curLang = res[0]
    if(mid){
      const _l = res.find(c => c.id === Number(mid) || c.url.slice(1) === mid)
      _l && (curLang = _l)
    }
    language.value = curLang
    languageList.value = res
  } catch(err) {
    console.error(err)
  }
}

watchEffect(async() => {
  // if(route.name === 'HelpCenter') {
    // const { mid } = route.params
    const mid = route.params.mid || route.query.mid
    await getTopicLanguageFn(mid as string) 
  // }
})

// const junp_ckip = () => {
//   let path = store.getters.language != 'en' ? 'https://help.kilimall.com/pcindex.php?lang=cn' :'https://help.kilimall.com/pcindex.php?lang=en'
//   window.open(path)
// }


return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_webp = _resolveDirective("webp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
          [_directive_webp]
        ])
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(language.value?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: index,
                    command: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.languageName), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(language.value?.languageName), 1),
              _createVNode(KlIcon, {
                style: { color: '#909399' },
                size: 18,
                icon: "bx-caret-down"
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})